import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { designedResponses, shapingInputs } from '../../data/comparison';
export function TemplateVsCustom() {
  return <section id="why-custom" className="relative overflow-hidden bg-mist-50 py-14 text-navy-900 lg:py-20" data-id="element-276" data-mp="2q25ds44ngt6z">
      <div className="absolute inset-0 bp-light" aria-hidden="true" data-id="element-277" data-mp="2lz8pbwsfi2v4" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-278" data-mp="2zzt84sycfyom">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-279" data-mp="2zxqapnuv339v">
          <div className="min-w-0 lg:col-span-7" data-id="element-280" data-mp="2v0gpylif3fsd">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-navy-600" data-id="element-281" data-mp="39pmnm51lwxy5">Why custom matters</p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-[1.12] tracking-[-0.02em] text-navy-900 sm:text-[2.1rem]" data-id="element-282" data-mp="34q9rsusrcgjf">
              Custom should change what the business can do—not just how the site looks.
            </h2>
          </div>
          <p className="min-w-0 text-[14.5px] leading-relaxed text-navy-700/80 lg:col-span-5" data-id="element-283" data-mp="3dpmyxgtest0z">
            Custom begins with the requirements standard packages often miss: how customers buy, how pricing works, where
            leads go, what systems need to exchange data, and what the team must be able to change later. WebsiteForge plans
            those rules into the system from the beginning.
          </p>
        </div>

        {/* inputs → designed response */}
        <div className="mt-10 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-0" data-id="element-284" data-mp="1e72rd6weasew">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4
        }} className="min-w-0 rounded-2xl border border-navy-900/10 bg-white p-6 lg:rounded-r-none" data-id="element-285" data-mp="1j54b7u1navrf">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.14em] text-navy-600" data-id="element-286" data-mp="1xtido3v5gi7g">What shapes the system</p>
            <ul className="mt-4 space-y-3" data-id="element-287" data-mp="2sgb2e6g3cun">
              {shapingInputs.map(item => <li key={item} className="flex min-w-0 gap-3 text-[14px] leading-snug text-navy-800" data-id="element-288" data-mp="2q2eg0w49skz">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-navy-400" aria-hidden="true" data-id="element-289" data-mp="bkqkht9ineau" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* connector */}
          <div className="flex items-center justify-center py-1 lg:w-16 lg:py-0" aria-hidden="true" data-id="element-290" data-mp="li4ylm7yvqzz">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-forge-orange text-ink" data-id="element-291" data-mp="gis3yfautfmu">
              <ArrowRightIcon className="h-5 w-5 rotate-90 lg:rotate-0" data-id="element-292" data-mp="uil2uxwjb25w" />
            </span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: 0.08
        }} className="relative min-w-0 overflow-hidden rounded-2xl bg-ink p-6 shadow-lift lg:rounded-l-none" data-id="element-293" data-mp="qjc8prxl129t">
            <div className="absolute inset-0 bp opacity-80" aria-hidden="true" data-id="element-294" data-mp="2m7186k6oi3zx" />
            <span className="absolute inset-x-0 top-0 h-[3px] bg-forge-orange" aria-hidden="true" data-id="element-295" data-mp="2m958yt9a6mvz" />

            <p className="relative font-mono text-[11.5px] uppercase tracking-[0.14em] text-forge-orange" data-id="element-296" data-mp="28djn2uycgj7s">
              What WebsiteForge designs around it
            </p>
            <ul className="relative mt-4 space-y-3" data-id="element-297" data-mp="1ygoo6ay5sgsz">
              {designedResponses.map(item => <li key={item} className="flex min-w-0 gap-3 text-[14px] font-medium leading-snug text-mist-100" data-id="element-298" data-mp="23i4bk9nt6zej">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-forge-orange" aria-hidden="true" data-id="element-299" data-mp="1piuwxef94dco" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <p className="mt-6 max-w-3xl border-l-2 border-forge-orange pl-5 text-[14px] leading-relaxed text-navy-700/85" data-id="element-300" data-mp="3otvyc08fzkz4">
          Platform control allows the experience, logic, integrations, and future changes to be planned together.
        </p>
      </div>
    </section>;
}